import { Box, Typography } from '@mui/material';

/**
 * Indicador de tablero con el formato de Finanzas: etiqueta, valor destacado y ayuda opcional.
 * @param {Object} props
 * @param {string} props.label Nombre del indicador.
 * @param {string|number} props.value Valor ya formateado.
 * @param {string} [props.helper] Texto secundario debajo del valor.
 * @returns {JSX.Element}
 */
const DashboardMetric = ({ label, value, helper }) => (
  <Box
    sx={{
      border: '1px solid',
      borderColor: 'primary.main',
      borderRadius: 1,
      backgroundColor: 'background.paper',
      minHeight: 78,
      px: 1.5,
      py: 1.25,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      minWidth: 0,
    }}
  >
    <Typography variant="caption" sx={{ color: 'primary.main', fontWeight: 800, lineHeight: 1.2 }}>
      {label}
    </Typography>
    <Typography
      variant="h6"
      sx={{
        color: 'primary.main',
        fontWeight: 900,
        lineHeight: 1.2,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
      title={String(value ?? '-')}
    >
      {value ?? '-'}
    </Typography>
    {helper && (
      <Typography
        variant="caption"
        sx={{ color: 'text.secondary', fontWeight: 600, lineHeight: 1.2 }}
      >
        {helper}
      </Typography>
    )}
  </Box>
);

export default DashboardMetric;
